
import { GeneralService } from 'src/app/services/general.service';
import { NotificationService } from './../../../services/notification.service';
import { FormularioService } from './../../../services/formulario.service';
import { Component, ElementRef, OnInit, ViewChild, AfterViewInit, ComponentFactoryResolver, ViewContainerRef, ComponentRef, Output, EventEmitter } from '@angular/core';
import { AbstractControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { GeneralComponent } from 'src/app/shared/general.component';
import { HttpErrorResponse } from '@angular/common/http';
import { TypeMessage } from 'src/app/entity/enum/enum-notification';
import { DropDownListDTO } from 'src/app/entity/dto/dropdownlist.component';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { LoteDsItemComponent } from 'src/app/shared/lote-ds-item/lote-ds-item.component';
import { select, Store } from '@ngrx/store';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'app-sec002-card-V',
    templateUrl: './sec002-card-V.component.html'
})

export class Sec002CardVComponent extends GeneralComponent implements OnInit {
    public formulario?: FormGroup;
    public listOptionsSapRw?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listOptionsSapDs?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listOptionsSapQuimicos?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listStatusSilo?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listOptionsSapRwOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listOptionsSapDsOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listOptionsSapQuimicosOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listStatusSiloOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();

    public filteredOptionsSapRw: Observable<DropDownListDTO[]>;
    public filteredOptionsSapDs: Observable<DropDownListDTO[]>;
    public filteredOptionsSapQuimicos: Observable<DropDownListDTO[]>;
    public filteredOptionsStatusSilo: Observable<DropDownListDTO[]>;

    @Output() mkCalc = new EventEmitter();
    @Output() updateLocalAtualEmitter = new EventEmitter();
    @ViewChild("viewContainerRef", { read: ViewContainerRef })
    VCR: ViewContainerRef;
    child_unique_key: number = -1;
    public disabledBtnRemove: boolean = true;
    lotesDsItemsReferences = Array<ComponentRef<LoteDsItemComponent>>()
    public readonly minItensOnList: number = 1;
    public readonly maxItensOnList: number = 10;

    sec002$: Observable<[]>;

    // tslint:disable-next-line: max-line-length
    constructor(protected formularioService: FormularioService, protected formBuilder: FormBuilder, protected notificationService: NotificationService, protected generalService: GeneralService, private CFR: ComponentFactoryResolver,
        private store: Store<{ sec002: [] }>,) {
        super('Apontamentos', false);
        if (this.isComercial || this.isBasica) {
            this.formulario = this.formBuilder.group({
                //  Peso_debulha_kg: [null, []],
                //  Lote_ds: [null, [Validators.pattern('\^([a-zA-Z]{6}[0-9]{4})$|([a-zA-Z]{6}[0-9]{4}[;]{1})+([a-zA-Z]{6}[0-9]{4}[;]?)')]],
                //  Silo_destino: [null, [Validators.pattern('\^([S]{1}[B]{1}[0-9]{2})$|([S]{1}[B]{1}[0-9]{2}[;]{1})+([S]{1}[B]{1}[0-9]{2}[;]?)')]],
                Status_silo: [null, []],
                Ordem_ds: [null, []],
                peso_debulha_kg_total: [null, []],
                Volume_calda_litros: [null, []],
                Calda_por_tonelada_l_ton: [null, []],
                Concentracao_k_obiol: [null, []],
                Concentracao_actellic: [null, []],
                K_obiol_litros: [null, []],
                Actellic_litros: [null, []],
                Check_sap_rw: [null, []],
                Check_sap_ds: [null, []],
                Check_sap_quimicos: [null, []],
            });
        } else {
            this.formulario = this.formBuilder.group({})
        }

        this.sec002$ = store.pipe(select('sec002'));
    }

    public async ngOnInit(): Promise<void> {
        await this.getLists();
        await this.getFilters();
        // await this.createLoteDsItemComponent();
    }

    public changeCollapse(): void {
        this.collapseCard = this.collapseCard ? false : true;
    }

    public hasErrorFormControl(campoFormulario?: AbstractControl): string {
        return this.formularioService.hasErrorFormControl(campoFormulario);
    }

    async getLists(): Promise<void> {
        await this.getListStatusSilo();
        await this.getListSapDs();
        await this.getListSapRw();
        await this.getListSapQuimicos();
    }

    async getFilters(): Promise<void> {
        // await this.createFilterSapRw();
        // await this.createFilterSapDs();
        // await this.createFilterSapQuimicos();
    }

    async makeCalculations(): Promise<void> {
        this.mkCalc.emit();
    }

    async createFilterSapRw(value: string): Promise<void> {
        if (!!value && value.length > 0) {
            if (this.listOptionsSapRwOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listOptionsSapRw = this.listOptionsSapRwOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listOptionsSapRw = this.listOptionsSapRwOriginal;
            }
        } else {
            this.listOptionsSapRw = this.listOptionsSapRwOriginal;
        }

        // this.filteredOptionsSapRw = this.formulario.get('Check_sap_rw').valueChanges
        //     .pipe(
        //         startWith(''),
        //         map(value => this.generalService._filterDropDownList(this.listOptionsSapRw, value))
        //     );
    }

    async createFilterSapDs(value: string): Promise<void> {
        if (!!value && value.length > 0) {
            if (this.listOptionsSapDsOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listOptionsSapDs = this.listOptionsSapDsOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listOptionsSapDs = this.listOptionsSapDsOriginal;
            }
        } else {
            this.listOptionsSapDs = this.listOptionsSapDsOriginal;
        }
        // this.filteredOptionsSapDs = this.formulario.get('Check_sap_ds').valueChanges
        //     .pipe(
        //         startWith(''),
        //         map(value => this.generalService._filterDropDownList(this.listOptionsSapDs, value))
        //     );
    }

    async createFilterSapQuimicos(value: string): Promise<void> {
        if (!!value && value.length > 0) {
            if (this.listOptionsSapQuimicosOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listOptionsSapQuimicos = this.listOptionsSapQuimicosOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listOptionsSapQuimicos = this.listOptionsSapQuimicosOriginal;
            }
        } else {
            this.listOptionsSapQuimicos = this.listOptionsSapQuimicosOriginal;
        }
        // this.filteredOptionsSapQuimicos = this.formulario.get('Check_sap_quimicos').valueChanges
        //     .pipe(
        //         startWith(''),
        //         map(value => this.generalService._filterDropDownList(this.listOptionsSapQuimicos, value))
        //     );
    }

    private async getListSapRw(): Promise<void> {
        await this.formularioService.getListDropDownList('sec002', 'check_sap_rw').pipe(take(1)).toPromise().then((response: any) => {
            if (!!response?.data) {
                this.listOptionsSapRw = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listOptionsSapRwOriginal = this.listOptionsSapRw;
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, error.message);
        });
    }

    private async getListSapDs(): Promise<void> {
        await this.formularioService.getListDropDownList('sec002', 'check_sap_ds').pipe(take(1)).toPromise().then((response: any) => {
            if (!!response?.data) {
                this.listOptionsSapDs = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listOptionsSapDsOriginal = this.listOptionsSapDs;
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, error.message);
        });
    }

    private async getListSapQuimicos(): Promise<void> {
        await this.formularioService.getListDropDownList('sec002', 'check_sap_quimicos').pipe(take(1)).toPromise().then((response: any) => {
            if (!!response?.data) {
                this.listOptionsSapQuimicos = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listOptionsSapQuimicosOriginal = this.listOptionsSapQuimicos;
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, error.message);
        });
    }

    async getListStatusSilo(): Promise<void> {
        await this.formularioService.getListDropDownList('sec002', 'status_silo').pipe(take(1)).toPromise().then(response => {
            if (!!response?.data) {
                this.listStatusSilo = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listStatusSiloOriginal = this.listStatusSilo;
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorStatusSilo);
        });
    }

    async createFilterStatusSilo(value: string): Promise<void> {
        if (!!value && value.length > 0) {
            if (this.listStatusSiloOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listStatusSilo = this.listStatusSiloOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listStatusSilo = this.listStatusSiloOriginal;
            }
        } else {
            this.listStatusSilo = this.listStatusSiloOriginal;
        }
    }
    public async addItem(): Promise<void> {
        this.disabledBtnRemove = false;
        this.createLoteDsItemComponent();
        this.updateLocalAtual();
    }

    public async removeItem(): Promise<void> {
        if (!!this.lotesDsItemsReferences) {
            this.lotesDsItemsReferences[this.lotesDsItemsReferences.length - 1].instance.remove(true);
            if (this.lotesDsItemsReferences.filter(x => x.instance.btnExcluir == false).length == 0) {
                this.disabledBtnRemove = true
            }
            this.updateLocalAtual();
        }
    }

    public createLoteDsItemComponent() {
        let componentFactory = this.CFR.resolveComponentFactory(LoteDsItemComponent);
        let childComponentRef = this.VCR.createComponent(componentFactory);
        childComponentRef.instance.mkCalc.subscribe(val => {
            this.formulario.controls.peso_debulha_kg_total.setValue(val);
        });
        childComponentRef.instance.loteDsDeletedEmitter.subscribe(
            () => {
                this.updateLocalAtual();
            });
        childComponentRef.instance.componentsReferences = this.lotesDsItemsReferences;
        let childComponent = childComponentRef.instance;
        childComponent.unique_key = ++this.child_unique_key;
        childComponent.parentRef = this;
        this.lotesDsItemsReferences.push(childComponentRef);
    }


    public removeLoteDsItemComponent(key: number, lastItem = false) {
        this.VCR.remove(lastItem ? this.VCR.length - 1 : key);
        this.lotesDsItemsReferences = this.lotesDsItemsReferences.filter(
            x => x.instance.unique_key !== key)
        this.lotesDsItemsReferences.forEach((x, index) => {
            x.instance.unique_key = index
        })
        --this.child_unique_key;
    }

    private updateLocalAtual(): void {
        this.updateLocalAtualEmitter.emit();
    }
}
